export default function Footer({ t, lang, navigate }) {
  const a11yLabel = lang === "DE" ? "Barrierefreiheit" : lang === "EN" ? "Accessibility" : "Accessibilité";
  const cookieLabel = lang === "DE" ? "Cookie-Einstellungen" : lang === "EN" ? "Cookie Settings" : "Paramètres cookies";

  return (
    <footer className="footer" data-testid="footer" role="contentinfo">
      <div className="footer-left">
        <div className="footer-logo" aria-hidden="true">UNDRIVE<sup className="footer-triangle-wrap"><svg className="footer-triangle" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0L28 0L28 28Z" fill="#E8952A"/></svg></sup><sup className="trademark">®</sup></div>
        <div className="footer-links">
          <button
            onClick={() => navigate('/impressum')}
            className="footer-link-btn"
            data-testid="footer-impressum-btn"
          >
            {t.impressum}
          </button>
          <span className="footer-divider" aria-hidden="true">·</span>
          <button
            onClick={() => navigate('/impressum')}
            className="footer-link-btn"
            data-testid="footer-datenschutz-btn"
          >
            {t.datenschutz}
          </button>
          <span className="footer-divider" aria-hidden="true">·</span>
          <button
            onClick={() => navigate('/barrierefreiheit')}
            className="footer-link-btn"
            data-testid="footer-barrierefreiheit-btn"
          >
            {a11yLabel}
          </button>
          <span className="footer-divider" aria-hidden="true">·</span>
          <button
            onClick={() => window.dispatchEvent(new Event("reopenCookieSettings"))}
            className="footer-link-btn"
            data-testid="footer-cookie-btn"
          >
            {cookieLabel}
          </button>
        </div>
      </div>
      <div className="footer-right">
        <a href="https://www.linkedin.com/company/undrive" target="_blank" rel="noopener noreferrer" className="footer-social-link" data-testid="footer-linkedin" aria-label="UNDRIVE auf LinkedIn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
        </a>
        <div className="footer-copyright">© 2026 UNDRIVE · Dominik Mietke</div>
      </div>
    </footer>
  );
}
